import { useEffect } from "react";
import { useAtom } from "jotai";
import { Link } from "react-router-dom";
// TODO: Remove Firebase Auth dependency
// import { signOut } from "firebase/auth";

// TODO: Implement stub signOut function
const signOut = async (auth: any) => {};

import { Button } from "@mui/material";

import AuthLayout from "@src/layouts/AuthLayout";

import { projectScope } from "@src/atoms/projectScope";
import { firebaseAuthAtom } from "@src/sources/ProjectSourceSupabase";

export default function SignOutPage() {
  const [firebaseAuth] = useAtom(firebaseAuthAtom, projectScope);

  useEffect(() => {
    signOut(firebaseAuth);
  }, [firebaseAuth]);

  return (
    <AuthLayout title="Signed out">
      <Button component={Link} to="/auth" variant="outlined">
        Sign in again
      </Button>
    </AuthLayout>
  );
}
